var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxtBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.004,
    height: 24.335,
    viewBox: "0 0 92.004 24.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M0-153.886H92v-24.335H0Z",
    transform: "translate(0 178.221)",
    fill: "#251f1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(0 178.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(0 -178.221)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(0 0.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M-153.477-76.708a12.133,12.133,0,0,0-11.944-12.13v4.549a7.621,7.621,0,0,1,7.431,7.618,7.623,7.623,0,0,1-7.623,7.623,7.594,7.594,0,0,1-5.186-2.038l-3.173,3.173a12.091,12.091,0,0,0,8.359,3.343,12.135,12.135,0,0,0,12.135-12.135m-17.451-5.423a7.6,7.6,0,0,1,5.125-2.159v-4.549a12.1,12.1,0,0,0-8.333,3.5Zm-.267.274-3.209-3.209a12.084,12.084,0,0,0-3.343,8.358,12.1,12.1,0,0,0,3.5,8.526l3.173-3.173a7.6,7.6,0,0,1-2.163-5.317,7.589,7.589,0,0,1,2.039-5.185",
    transform: "translate(177.748 88.838)",
    fill: "#251f1c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(0 -178.221)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(3.611 0.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M-52.7-28.764v-4.549a12.1,12.1,0,0,0-8.333,3.5l3.209,3.208A7.6,7.6,0,0,1-52.7-28.764",
    transform: "translate(61.029 33.313)",
    fill: "#251f1c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(3.611 0.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M-52.7-28.764v-4.549a12.1,12.1,0,0,0-8.333,3.5l3.209,3.208A7.6,7.6,0,0,1-52.7-28.764Z",
    transform: "translate(61.029 33.313)",
    fill: "#251f1c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(28.913 0.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M-74.305-104.518a7.069,7.069,0,0,1-1.162.4,4.32,4.32,0,0,1-1.033.145,1.344,1.344,0,0,1-.969-.339,1.588,1.588,0,0,1-.355-1.178V-111.1H-74.5v-4.616h-3.325v-5.327h-6.133v5.327h-2.1v4.616h2.1v7.78a5.877,5.877,0,0,0,.4,2.324,4,4,0,0,0,1.1,1.517,4.267,4.267,0,0,0,1.63.839,7.374,7.374,0,0,0,1.969.258,11.779,11.779,0,0,0,2.889-.371,18.788,18.788,0,0,0,2.76-.92Zm10.517,5.343a7.815,7.815,0,0,0,2.615-2.211l.129.613a2.783,2.783,0,0,0,1.114,1.759,4.361,4.361,0,0,0,2.5.6,9.913,9.913,0,0,0,1.178-.081q.661-.081,1.4-.242V-103.9a1.233,1.233,0,0,1-.9-.4,2.078,2.078,0,0,1-.258-1.211v-3.293a6.619,6.619,0,0,0-2.2-5.423,9.612,9.612,0,0,0-6.263-1.808,13.818,13.818,0,0,0-7.651,2.163l1.775,3.809a13.207,13.207,0,0,1,2.583-1.372,7.462,7.462,0,0,1,2.679-.468,3.484,3.484,0,0,1,2.244.581,2.186,2.186,0,0,1,.694,1.775v.517a7.959,7.959,0,0,0-3.422-.646,9.851,9.851,0,0,0-2.954.42,7,7,0,0,0-2.308,1.194,5.653,5.653,0,0,0-1.517,1.84,5.065,5.065,0,0,0-.549,2.357,5.187,5.187,0,0,0,.452,2.163A5.246,5.246,0,0,0-71.2-99.982a5.835,5.835,0,0,0,1.889,1.146,6.55,6.55,0,0,0,2.357.42,6.862,6.862,0,0,0,3.164-.759m-2.76-4.084a1.421,1.421,0,0,1-.565-1.162,1.663,1.663,0,0,1,.743-1.388,3.065,3.065,0,0,1,1.872-.549,6.018,6.018,0,0,1,1.162.129,8.787,8.787,0,0,1,1.195.323v1.259a1.052,1.052,0,0,1-.226.629,2.642,2.642,0,0,1-.581.565,4.131,4.131,0,0,1-1.033.468,3.854,3.854,0,0,1-1.13.178,2.225,2.225,0,0,1-1.436-.452m12.3-12.461,5.682,8.49-5.843,8.49h6.23l2.615-4.164.29-.646.291.646,2.615,4.164h6.23l-5.843-8.49,5.682-8.49h-6.23l-2.421,4.164-.323.678-.323-.678-2.421-4.164Zm30.183,11.2a7.066,7.066,0,0,1-1.162.4,4.32,4.32,0,0,1-1.033.145,1.344,1.344,0,0,1-.968-.339,1.588,1.588,0,0,1-.355-1.178V-111.1h3.325v-4.616h-3.325v-5.327h-6.133v5.327h-2.1v4.616h2.1v7.78a5.875,5.875,0,0,0,.4,2.324,4,4,0,0,0,1.1,1.517,4.268,4.268,0,0,0,1.63.839,7.376,7.376,0,0,0,1.969.258,11.78,11.78,0,0,0,2.889-.371,18.8,18.8,0,0,0,2.76-.92Z",
    transform: "translate(86.056 121.046)",
    fill: "#251f1c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxtBlack);
export default __webpack_public_path__ + "static/media/taxt-black.6be934a5d30e191be49f1acae33d019f.svg";
export { ForwardRef as ReactComponent };